// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper .content[data-v-67d17f50]{background-repeat:no-repeat;background-position:0 0;background-size:cover;padding:0 .3rem .2rem}.wrapper .banner[data-v-67d17f50]{width:100%;height:auto;margin-bottom:.24rem}.wrapper .detail-banner[data-v-67d17f50]{width:6.9rem;margin:0 auto .24rem;border-radius:.12rem}", ""]);
// Exports
module.exports = exports;
